import React from 'react'

import { Redirect, Router, Route, IndexRoute, IndexRedirect } from 'react-router'
import { browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'

import App from './views/App'

import Login from 'partner/views/Login'
import ResetPassword from 'partner/views/ResetPassword'
import ChangePassword from 'partner/views/ChangePassword'

import Layout from './views/Layout'
import Dashboard from './views/Dashboard'
import Index from './views/Index'
import Assignments from './views/Assignments'
import ManageUsers from './views/ManageUsers'
import LeadSources from './views/LeadSources'
import LikelyCloses from './views/LikelyCloses'
import UnpaidCloses from './views/UnpaidCloses'
import Reports from './views/Reports'
import ReleasedAssignments from './views/ReleasedAssignments'
import LeadsWrapper from './views/LeadsWrapper'
import LeadsLeadSources from './views/components/Deprecating/LeadSources/LeadSources'
import LeadsLeadList from './views/components/Deprecating/LeadSources/LeadsList'
import Support from './views/Support'
import TermsAndConditions from './views/components/TermsAndConditions'
import ReferralFees from './views/components/ReferralFees/ReferralFees'
import { selectIsAuthenticated, selectIsMasquerade } from 'common/redux/selectors/auth'
import { selectNewBrokerPortalCashbackTerms, selectNewBrokerDashboardFlag, selectNewLeadsPageFlag, selectEnableVIPDashboardFlag } from 'broker/selectors/auth'


export default (store) => {
  const history = syncHistoryWithStore(browserHistory, store)
  const { getState } = store
  const hasNewDashboard = selectNewBrokerDashboardFlag(getState())
  const hasNewLeadsPageFlag = selectNewLeadsPageFlag(getState())

  function isAuthenticated() {
    return selectIsAuthenticated(getState())
  }

  function requireAuth(nextState, replaceState) {
    if (!isAuthenticated()) {
      replaceState({pathname: '/login'})
    }
  }

  function canAcknowledgeTermsAndConditions() {
    // These are used for the terms and conditions component
    const { auth } = getState()
    const { user } = auth
    const { acknowledged_terms_conditions_at } = user
    const hasBrokerPortalCashbackTermsFlag = selectNewBrokerPortalCashbackTerms(getState())
    const userIsMasqueraded = selectIsMasquerade(getState())

    return hasBrokerPortalCashbackTermsFlag && !acknowledged_terms_conditions_at && !userIsMasqueraded
  }

  function requireAcknowledgeTermsConditions(nextState, replaceState) {

    /* If our path is a blacklisted path and we have not acknowledged the terms and conditions
     * then redirect to the dashboard.
     */
    if (canAcknowledgeTermsAndConditions()) {
      replaceState({pathname: "/"})
    }
  }

  function skipLogin(nextState, replaceState) {
    if (isAuthenticated()) {
      replaceState({pathname: '/'})
    }
  }

  let tabs = [
    {label: 'Dashboard', value: '/'},
    {label: 'Likely Closes', value: '/likely-closes'},
    {label: 'Unpaid Closes', value: '/unpaid-closes'},
    {label: 'Referrals', value: '/referrals'},
    {label: 'Released Referrals', value: '/released-referrals'},
    hasNewLeadsPageFlag ? {label: 'Leads', value: '/leads'} : {label: 'Lead Sources', value: '/lead-sources'}
  ]

  const showVIPDashbaord = selectEnableVIPDashboardFlag(getState())
  if (showVIPDashbaord) {
    tabs = tabs.concat([{label: 'Market VIP', outboundLocation: '/vip-portal'}])
  }

  tabs = tabs.concat([
    {label: 'Reports', value: '/reports'},
    {label: 'Users', value: '/add-users'},
    {label: 'Support', value: '/support'}
  ])

  const LayoutWrapper = props => (
    <Layout tabs={tabs}>
      {props.children}
    </Layout>
  )

  const LoginWrapper = () => <Login title="Broker Portal"/>

  return (
    <Router history={history}>
      <Route path="/" component={App}>
        <Route onEnter={requireAuth} component={LayoutWrapper}>
          <IndexRoute component={hasNewDashboard ? Dashboard : Index}/>
          <Route onEnter={requireAcknowledgeTermsConditions}>
            <Redirect from='add-agent' to='add-users'/>
            <Route path="referrals" component={Assignments}/>
            <Route path="released-referrals" component={ReleasedAssignments}/>
            <Route path="likely-closes" component={LikelyCloses}/>
            <Route path="unpaid-closes" component={UnpaidCloses}/>
            <Route path="add-users" component={ManageUsers}/>
            <Route path="lead-sources" component={LeadSources}/>
            { hasNewLeadsPageFlag ?
              <Route component={LeadsWrapper} path="leads">
                <IndexRedirect to="sources"/>
                <Route path="sources" component={LeadsLeadSources}/>
                <Route path="list" component={LeadsLeadList}/>
              </Route> :
              null
            }
          </Route>
          <Route path="reports" component={Reports}/>
          <Route path="support" component={Support}/>
          <Route path="terms" component={TermsAndConditions}/>
          <Route path="referral-fees" component={ReferralFees}/>
        </Route>
        <Route path="login" onEnter={skipLogin} component={LoginWrapper}/>
        <Route path="reset_password" onEnter={skipLogin} component={ResetPassword}/>
        <Route path="change_password/:hash" onEnter={skipLogin} component={ChangePassword}/>
      </Route>
    </Router>
  )
}
